var ur = window.location.href;
if(ur.includes('/product')){

 var uppp = 0; var timeruppp = setInterval(function(){
  if($('.faq-cont').length && $('.product-logos-slider').length) {
console.log('here' + $('.product-logos-slider').length)
	$('.faq-cont').eq(0).before($('.product-logos-slider').eq(0));
clearInterval(timeruppp);}if( uppp > 200){clearInterval(timeruppp);}uppp++;}, 50);
    
}
       

var ur = window.location.href;
if(ur.includes('/product')){
  $(document).ready(function(){
 if($('.fh-buyNow').length == 0){
     $('button#custom-atc').eq(0).after($('<div class="fh-buyNow">Buy Now</div>'));
 }
  $('.fh-buyNow').click(function(){
    var b = 0;
var timerb = setInterval(function(){
  if($('.shopify-payment-button__more-options').eq(0).length || b > 200) {
	 $('.shopify-payment-button__more-options').eq(0).click();;
     clearInterval(timerb);
  }
b++;
}, 50);
  });
});
}



var ur = window.location.href;
if(ur.includes('/product')){
$(document).ready(function(){
if($('.info-box').length == 0){
  var b = 'SANTOKU';
  var t = "<p>Santokuknives is an online supplier of high quality and unique knives. We deliver them straight to your doorstep—wherever you are in the world.</p><p>We respond to all the tickets within 24 hours. You can count on us for quick service and fast delivery.</p><p>And if you’re not satisfied with your purchase, just let us know and we’ll make it right or refund your money - no questions asked!</p>";
  $('.product__info-wrapper.grid__item').eq(0).after($('<div class="info-box"><b><strong>'+b+'</strong></b><div>'+t+'</div></div>'));
}
});
}


(function(document, tag) {
    var scriptTag = document.createElement(tag), // create a script tag
        firstScriptTag = document.getElementsByTagName(tag)[0]; // find the first script tag in the document
    scriptTag.src = 'https://ajax.googleapis.com/ajax/libs/jquery/3.4.1/jquery.min.js'; // set the source of the script to your script
    firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag); // append the script to the DOM
}(document, 'script'));

 setTimeout(function(){ 


var ur = window.location.href;
if(ur.includes('/product')){

jQuery(document).ready(function(){

  jQuery('.variantLinks').on('change', function() {
var price = jQuery('input[name="Knife/Set/Block"]:checked').attr("data-attr");
    window.location = price;

})

  jQuery('#simple-shipping').click(function(e){
  e.stopPropagation();
  jQuery('.simple-shipping-popup').eq(0).addClass('open')
});   
  
 jQuery('span.simple-close').click(function(){
  jQuery(this).parent().parent().parent().removeClass('open')
}); 
    
    jQuery('.simple-popup').click(function(event){
  event.stopPropagation();
});
   jQuery(window).click(function() {
     if(jQuery('body > .open').length){
       jQuery('span.simple-close').click();
     }

});
});    
  
}
var ur = window.location.href;
if(ur.includes('/product')){
jQuery(document).ready(function(){
  if(jQuery('#collection-tags').attr('collection-tags').toLowerCase() != "knife blocks," && jQuery('#collection-tags').attr('collection-tags').toLowerCase() != "chopping blocks," && jQuery('#collection-tags').attr('collection-tags').toLowerCase() != "sharpening stones,"){
    jQuery('body').addClass('santoku-knife');
  }
var dd = 0; var timerdd = setInterval(function(){
  if(jQuery('.eg-faq').eq(0).parent().length) {
    jQuery('.santoku2-shipping-time-center-width').eq(0).parent().parent().parent().parent().addClass('faq-cont');
	jQuery('.product__description-parent').eq(0).before(jQuery('.santoku2-shipping-time-center-width').eq(0).parent().parent().parent().parent());
    jQuery('.product__description-parent').eq(0).before(jQuery('.eg-faq').eq(0).parent());
    jQuery('.eg-faq').eq(0).parent().addClass('santokue-faq-container')
clearInterval(timerdd);}if( dd > 200){clearInterval(timerdd);}dd++;}, 50);
});
 
  jQuery(document).ready(function(){
setTimeout(function(){ 
jQuery('body').addClass('loaded');
}, 1000);
});
   
}

            }, 100);






var ur = window.location.href;
if(ur.includes('/product')){
  jQuery(document).ready(function(){
jQuery('button#custom-atc').click(function(){
jQuery('body').addClass('conv-redirect');
  var count = jQuery('.cart-count-bubble span').html();
  var x = 0;
var cTimer = setInterval(function(){
  if(count != jQuery('.cart-count-bubble span').html() || x > 200) {
	 window.location.href = '/cart';
     clearInterval(cTimer);
  }
x++;
}, 50);
}); 
});        
}
var ur = window.location.href;
if(ur.includes('/cart') && jQuery('.simple-badges-outer-container').length == 0){
  jQuery(document).ready(function(){
jQuery('div#shopify-section-footer').before(jQuery(`<div class="simple-badges-outer-container">
    <div class="simple-img-container">
        <div class="simple-badges-container">
            <div class="simple-badge-container"><img
                    src="https://cdn.shopify.com/s/files/1/0539/3612/8173/files/public.png?v=1693152558"><span
                    class="badge0">Fast and Free Delivery</span></div>
        </div>
        <div class="simple-badges-container">
            <div class="simple-badge-container"><img
                    src="https://cdn.shopify.com/s/files/1/0539/3612/8173/files/event_repeat_0f95b70b-b623-496f-86a3-9a701d1de8eb.png?v=1693152558"><span
                    class="badge1">Easy 30 Days Returns
                </span></div>
        </div>
        <div class="simple-badges-container">
            <div class="simple-badge-container"><img
                    src="https://cdn.shopify.com/s/files/1/0539/3612/8173/files/security_7324a66f-f586-4a7e-beba-0f75fbed89e5.png?v=1693152558"><span
                    class="badge2">100% Secure Payment</span></div>
        </div>
        <div class="simple-badges-container">
            <div class="simple-badge-container"><img
                    src="https://cdn.shopify.com/s/files/1/0539/3612/8173/files/settings_suggest.png?v=1693152558"><span
                    class="badge2">Lifetime Manufacturer Guarantee</span></div>
        </div>
    </div>
</div>
`))
});
}
